export const TOKEN_STORAGE_KEYS = {
  ACCESS_TOKEN: 'accessToken',
  SCHOOL_AUTH_DATA: 'KH.AuthData',
  USER_CLAIMS: 'userClaims',
  POST_LOGOUT_REDIRECT: 'postLogoutRedirect',
  POST_EDLINK_REDIRECT:'postEdLinkRedirect'
};
